import {
  UNIT_DELETE_UNIT_BEGIN,
  UNIT_DELETE_UNIT_SUCCESS,
  UNIT_DELETE_UNIT_FAILURE,
  UNIT_DELETE_UNIT_DISMISS_ERROR,
} from './constants';



import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';

let tableRef = null;

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function deleteUnit(_tableRef,unitID,args = {}) {

  tableRef = _tableRef;
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: UNIT_DELETE_UNIT_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      axios.post(SERVER_PATH + '/units/edit', {
        unit:{
        "unit":unitID+'',
        "status":"0"
        }
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          dispatch({
            type: UNIT_DELETE_UNIT_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: UNIT_DELETE_UNIT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissDeleteUnitError() {
  return {
    type: UNIT_DELETE_UNIT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case UNIT_DELETE_UNIT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        deleteUnitPending: true,
        deleteUnitError: null,
      };

    case UNIT_DELETE_UNIT_SUCCESS:
      tableRef.current && tableRef.current.onQueryChange();
      // The request is success
      return {
        ...state,
        deleteUnitPending: false,
        deleteUnitError: null,
      };

    case UNIT_DELETE_UNIT_FAILURE:
      // The request is failed
      return {
        ...state,
        deleteUnitPending: false,
        deleteUnitError: action.data.error,
      };

    case UNIT_DELETE_UNIT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deleteUnitError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/unit/redux/deleteUnit.js